import React from 'react'
import ATTabs from '../../components/layoutComponent/tabs/ATTabs'
import Roles from '../../components/usermanagement/roles/Roles'
import User from '../../components/usermanagement/users/User'
import { usermanagementTabs } from '../../components/usermanagement/userManagementConstants'
import useUserManagement from '../../customHooks/usermanagement/useUserManagement'
import './UsersManagement.css'
import { useTranslation } from 'react-i18next'

const UsersManagement: React.FC = () => {
  const { t } = useTranslation(['translation'])
  const { handleTabSelection, selectedTab } = useUserManagement()
  const getJsxConditionally = () => {
    if (selectedTab === 'platform_roles')
      return <Roles key="platform_roles" isMaster={false} />
    else if (selectedTab === 'master_roles')
      return <Roles key="master_roles" isMaster={true} />
    else return <User />
  }

  return (
    <div className="users-management-container multi-tabs hm-class">
      <p className="title px-3 my-0 py-2">{t('common.usermanagement')}</p>
      <div className="content m-3 mt-0 border bg-white">
        <div className="tabs-wrapper pt-2">
          <ATTabs
            tabDetails={usermanagementTabs}
            onTabSelect={handleTabSelection}
            activeKey={selectedTab}
            showIcon={false}
          />
        </div>
        <div className="tab-body">{getJsxConditionally()}</div>
      </div>
    </div>
  )
}

export default UsersManagement
